/* global graphql */
import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bs-grid';
import BodyClassName from 'react-body-classname';
import Helmet from 'react-helmet';
import { ChevronUp } from 'react-feather';
import {
  Svg,
  Rect,
} from '@potion/element';
import { Pattern, LinearGradient } from '@potion/extra';
import Link from 'gatsby-link';
import WindowSize from 'react-window-size';
import get from 'lodash/get';
import { Fab, FabButton } from 'react-fab';

import Space from '../components/Space';
import Title from '../components/Title';
import Page from '../components/Page';

class Extra extends Component {
  componentDidMount() {
    if (Prism) Prism.highlightAll();
  }

  getDocs() {
    const edges = get(this.props, 'data.allMarkdownRemark.edges');
    if (!edges) return '';
    const { html } = edges.filter(edge => edge.node.html.indexOf('name="extras"') > -1)[0].node;
    return html.slice(html.indexOf('<h2>'));
  }
  scrollTo(key) {
    return () => {
      document.querySelector(`[name="elements__${key}"]`).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    };
  }

  render() {
    const { windowWidth, windowHeight } = this.props;
    const height = windowHeight;
    const patternsWidth = windowWidth;
    return (
      <BodyClassName className={'no-padding'}>
        <Page fluid name="page-build">
          <Helmet
            title="Potion.js - React + D3"
            meta={[
              {
                property: 'og:url',
                content: 'http://numberpicture.com/build',
              },
              {
                property: 'og:title',
                content: 'Potion.js - React + D3',
              },
              {
                property: 'og:description',
                content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.',
              },
              {
                name: 'twitter:title',
                content: 'Potion.js - React + D3',
              },
              {
                name: 'twitter:description',
                content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.',
              },
              {
                charSet: 'utf-8',
              },
            ]}
          />

          <Fab style={{ right: '20px', bottom: '20px' }}>
            <FabButton>
              <a onClick={this.scrollTo('top')}>
                <ChevronUp />
              </a>
            </FabButton>
          </Fab>

          <Container fluid>
            <Row>
              <Container>
                <Row>
                  <Col lg={12}>
                    <div name="elements__top" />
                    <Title>Extras</Title>
                  </Col>
                </Row>
                <Row>
                  <Col lg={8}>
                    <p>Potion Extras are presentational React components that can be used to enrich visualizations visually. Use them to add fill effects and other meta elements to the canvas like axes, legends and gridlines (still in development).</p>
                  </Col>
                  <Space half />
                </Row>
              </Container>
              <Container fluid>
                <Row>

                  <Container>
                    <h3>Patterns</h3>
                  </Container>
                  <Svg width={windowWidth} height={windowHeight}>
                    <Pattern.Lines
                      id="lines1"
                      strokeWidth={1}
                      stroke="black"
                      size={10}
                      orientation="diagonal"
                      background="white"
                    />
                    <Pattern.Lines
                      id="lines2"
                      strokeWidth={1}
                      stroke="black"
                      size={10}
                      orientation="vertical"
                      background="white"
                    />
                    <Pattern.Lines
                      id="lines3"
                      strokeWidth={1}
                      stroke="black"
                      size={12}
                      orientation="horizontal"
                      background="white"
                    />

                    <Pattern.Circles
                      id="circles1"
                      // strokeWidth={1}
                      radius={1}
                      stroke="black"
                      size={10}
                      background="white"
                    />
                    <Pattern.Circles
                      id="circles2"
                      strokeWidth={1}
                      stroke="black"
                      background="white"
                      radius={4}
                      fill="transparent"
                    />

                    <Pattern.Paths
                      id="paths1"
                      strokeWidth={1}
                      size={16}
                      stroke="black"
                      background="white"
                      d="nylon"
                      fill="transparent"
                    />

                    <Pattern.Paths
                      id="paths2"
                      strokeWidth={1}
                      size={16}
                      stroke="black"
                      background="white"
                      d="waves"
                      fill="transparent"
                    />

                    <Pattern.Paths
                      id="paths3"
                      strokeWidth={1}
                      size={16}
                      stroke="black"
                      background="white"
                      d="woven"
                      fill="transparent"
                    />

                    <Pattern.Paths
                      id="paths4"
                      strokeWidth={1}
                      size={16}
                      stroke="black"
                      background="white"
                      d="caps"
                      fill="transparent"
                    />

                    <Pattern.Paths
                      id="paths5"
                      strokeWidth={1}
                      size={16}
                      stroke="black"
                      background="white"
                      d="crosses"
                      fill="transparent"
                    />

                    <Rect
                      fill={'url(#lines2)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={0}
                      y={0}
                    />
                    <Rect
                      fill={'url(#lines1)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={patternsWidth / 5}
                      y={0}
                    />
                    <Rect
                      fill={'url(#lines3)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 2}
                      y={0}
                    />
                    <Rect
                      fill={'url(#circles1)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 3}
                      y={0}
                    />
                    <Rect
                      fill={'url(#paths1)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 4}
                      y={0}
                    />
                    <Rect
                      fill={'url(#circles2)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={0}
                      y={height / 2}
                    />
                    <Rect
                      fill={'url(#paths2)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={patternsWidth / 5}
                      y={height / 2}
                    />
                    <Rect
                      fill={'url(#paths3)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 2}
                      y={height / 2}
                    />
                    <Rect
                      fill={'url(#paths4)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 3}
                      y={height / 2}
                    />
                    <Rect
                      fill={'url(#paths5)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 4}
                      y={height / 2}
                    />
                  </Svg>

                  <Space />

                  <Container>
                    <h3>Gradients</h3>
                  </Container>
                  <Svg width={windowWidth} height={windowHeight}>
                    <LinearGradient
                      id="gradient1"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />
                    <LinearGradient
                      id="gradient2"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />
                    <LinearGradient
                      id="gradient3"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />
                    <LinearGradient
                      id="gradient4"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />
                    <LinearGradient
                      id="gradient5"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />
                    <LinearGradient
                      id="gradient6"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />
                    <LinearGradient
                      id="gradient7"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />
                    <LinearGradient
                      id="gradient8"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />
                    <LinearGradient
                      id="gradient9"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />
                    <LinearGradient
                      id="gradient10"
                      x1="0%"
                      y1="0%"
                      x2="0%"
                      y2="100%"
                    />

                    <Rect
                      fill={'url(#gradient1)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={0}
                      y={0}
                    />
                    <Rect
                      fill={'url(#gradient2)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={patternsWidth / 5}
                      y={0}
                    />
                    <Rect
                      fill={'url(#gradient3)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 2}
                      y={0}
                    />
                    <Rect
                      fill={'url(#gradient4)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 3}
                      y={0}
                    />
                    <Rect
                      fill={'url(#gradient5)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 4}
                      y={0}
                    />
                    <Rect
                      fill={'url(#gradient6)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={0}
                      y={height / 2}
                    />
                    <Rect
                      fill={'url(#gradient7)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={patternsWidth / 5}
                      y={height / 2}
                    />
                    <Rect
                      fill={'url(#gradient8)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 2}
                      y={height / 2}
                    />
                    <Rect
                      fill={'url(#gradient9)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 3}
                      y={height / 2}
                    />
                    <Rect
                      fill={'url(#gradient10)'}
                      height={height / 2}
                      width={patternsWidth / 5}
                      x={(patternsWidth / 5) * 4}
                      y={height / 2}
                    />
                  </Svg>
                </Row>
              </Container>

              <Container>
                <div className="page page-docs">
                  <div className="content">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.getDocs(),
                      }}
                    />
                  </div>
                </div>

                <Space />
                <Space />

              </Container>
            </Row>
          </Container>
        </Page>
      </BodyClassName>
    );
  }
}

export default WindowSize(Extra);

export const pageQuery = graphql`
  query ExtrasQuery {
    allMarkdownRemark {
      edges {
        node {
          html
          headings {
            depth
            value
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/extras.js